/*
 * QuestionnaireSection Messages
 *
 * This contains all the text for the QuestionnaireSection component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.QuestionnaireSection';

export default defineMessages({
  section: {
    id: `${scope}.section`,
    defaultMessage: 'Section',
  },
  of: {
    id: `${scope}.of`,
    defaultMessage: 'of',
  },
  postText: {
    id: `${scope}.postText`,
    defaultMessage: 'Post text (optional)',
  },
  preText: {
    id: `${scope}.preText`,
    defaultMessage: 'Pre text (optional)',
  },
});
